import { API_URL as ENDPOINT } from "../config/env";

export async function FacturasAdd(data, token) {
    return fetch(`${ENDPOINT}FacturasAdd`, {
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Authorization': `${token}`
        },
        method: 'post',
        body: data
    }).then(res => res.json()).then(response => {
        return response;
    });
}

/** Aprueba o rechaza la factura que subió el proveedor. */
export async function FacturaRevisar(data, token) {
    return fetch(`${ENDPOINT}FacturaRevisar`, {
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'Authorization': `${token}`
        },
        method: 'post',
        body: JSON.stringify(data)
    }).then(res => res.json()).then(response => {
        return response;
    });
}
